/**
 * Resolves accommodation ID from available data sources.
 * Single source of truth for ID resolution logic.
 *
 * Priority order:
 * 1. Direct accommodation_id from room type (most reliable - from API response)
 * 2. accommodation_id in metadata (from search results)
 * 3. content_id (may be accommodation ID for accommodations)
 * 4. metadata content_id as fallback
 */

interface RoomType {
  id: string;
  accommodation_id?: string;
  [key: string]: unknown;
}

interface SearchResultItem {
  id?: string;
  content_id?: string;
  metadata?: {
    accommodation_id?: string;
    content_id?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export function resolveAccommodationId(
  roomType: RoomType | null | undefined,
  selectedItem: SearchResultItem | null | undefined
): string | null {
  // Priority 1: Direct accommodation_id from room type (most reliable)
  if (roomType?.accommodation_id) {
    return roomType.accommodation_id;
  }

  // Priority 2: accommodation_id in metadata (from search results)
  if (selectedItem?.metadata?.accommodation_id) {
    return selectedItem.metadata.accommodation_id;
  }

  // Priority 3: content_id (may be accommodation ID for accommodations)
  if (selectedItem?.content_id) {
    return selectedItem.content_id;
  }

  // Priority 4: metadata content_id as fallback
  if (selectedItem?.metadata?.content_id) {
    return selectedItem.metadata.content_id;
  }

  return null;
}
